import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeSeemorpc', function () {
        const el = $(this);
        return {
            swiperOptionTwo: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: {
                  delay: 2500,
                  stopOnLastSlide: false,
                  disableOnInteraction: true,
                },
                pagination: {
                  el: '.swiper-pagination-two',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next-two',
                  prevEl: '.swiper-button-prev-two',
                },
                slidesPerView: 'auto',
                spaceBetween: 16,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {
                    this.autoplay.start()
                  },
                },
            },
            localName: window.Shopify.locale,
            init() {
                this.initPC()
            }, // end init
            initPC() {
                this.initPCSwiper()
            },
            initPCSwiper() {
                new Swiper('.swiper-container-seemor-pc', this.swiperOptionTwo)
            },
        }
    })
}
document.addEventListener('alpine:init', main)